import {checkCircleSvg as Icon__small__checkCircleSvg} from '../Icon__small/Icon__small--checkCircle.js'

export var checkCircle = {
  name: 'checkCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__checkCircleSvg,
};
